module.exports = __webpack_public_path__ + "img/role02.6367fabc.png";